<template>
  <a href="https://getbiew.com/" class="biew-badge">
    Made with
    <span class="has-text-weight-bold">Biew</span>
  </a>
</template>

<script>
export default {
  name: "BiewBadge"
};
</script>

<style lang="scss" scoped>
.biew-badge {
  position: fixed;
  right: 1em;
  bottom: 1em;
  background-color: #222;
  padding: 0.5em 0.8em;
  border-radius: 1em;
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.2);
  color: #fff;
  transition: all 0.3s ease;

  a {
    color: #fff;
  }
}

.biew-badge:hover {
  bottom: 1.5em;
}
</style>
